function VerticalDashIcon() {
  return(
    <svg width="2" height="586" viewBox="0 0 2 586" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" y1="0.5" x2="1" y2="1071.5" stroke="#D9D9D9" strokeLinecap="square" strokeDasharray="2 2"/>
    </svg>
  );
}

export default VerticalDashIcon;

